var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.435 6.29289C18.8256 5.90237 19.4587 5.90237 19.8492 6.29289C20.2398 6.68342 20.2398 7.31658 19.8492 7.70711L9.24264 18.3137L4.29289 13.364C3.90237 12.9734 3.90237 12.3403 4.29289 11.9497C4.68342 11.5592 5.31658 11.5592 5.70711 11.9497L9.24264 15.4853L18.435 6.29289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.84ca85382da9e86ca654258fc92ab36a.svg";
export { ForwardRef as ReactComponent };